export const PAGE_TITLE = 'Linear Optimizations';

export const DOWNLOAD_OPTION_MEDIA_PLAN = 'Media Plan (Full Run)';
export const DOWNLOAD_OPTION_BUYING_INSTRUCTIONS = 'Buying Instructions (Custom Export)';
export const DOWNLOAD_OPTION_CONSTRAINT_DEBUGGER = 'Constraint Debugger Data';

export const DOWNLOAD_MENU_OPTIONS = [
  DOWNLOAD_OPTION_MEDIA_PLAN,
  DOWNLOAD_OPTION_BUYING_INSTRUCTIONS,
  DOWNLOAD_OPTION_CONSTRAINT_DEBUGGER
];
